/* Add presentation only. Judge.me remains the source of review data and actions. */
(() => {
  const enhance = (widget) => {
    const controls = widget.querySelector('.jm-review-widget-sidebar-header__tabs .jdgm-tablist__content');
    if (controls && !controls.querySelector('.gp-review-list-title')) {
      const title = document.createElement('h2');
      title.className = 'gp-review-list-title';
      title.textContent = 'Top reviews';
      controls.prepend(title);
    }
    const rows = [...widget.querySelectorAll('.jm-histogram-row')];
    if (controls && rows.length === 5) {
      let filters = controls.querySelector('.gp-review-rating-filters');
      if (!filters) {
        filters = document.createElement('div');
        filters.className = 'gp-review-rating-filters';
        filters.setAttribute('role', 'group');
        filters.setAttribute('aria-label', 'Filter reviews by rating');
        for (const rating of [0, 5, 4, 3, 2, 1]) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.rating = rating;
          button.addEventListener('click', () => {
            if (rating === 0) widget.querySelector('.jm-filter-panel__clear-btn')?.click();
            else [...widget.querySelectorAll('.jm-histogram-row')].find(row => Number(row.querySelector('.jm-histogram-row__rating')?.textContent) === rating)?.click();
            requestAnimationFrame(() => enhance(widget));
          });
          filters.append(button);
        }
        controls.querySelector('.gp-review-list-title').after(filters);
      }
      const counts = new Map(rows.map(row => [Number(row.querySelector('.jm-histogram-row__rating')?.textContent), row.querySelector('.jm-histogram-row__frequency')?.textContent.trim() || '0']));
      const active = Number(widget.querySelector('input[name="rating-filter"]:checked')?.value || 0);
      for (const button of filters.children) {
        const rating = Number(button.dataset.rating);
        const count = rating ? counts.get(rating) : widget.querySelector('.jm-average-rating-display .jm-text:last-of-type')?.textContent.trim().replace(/\s+reviews?$/i, '');
        const label = `${rating ? rating + ' Star' : 'All Reviews'}${count ? ' (' + count + ')' : ''}`;
        if (button.textContent !== label) button.textContent = label;
        const pressed = String(active === rating);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      }
    } else controls?.querySelector('.gp-review-rating-filters')?.remove();
    const average = widget.querySelector('.jm-average-rating-display');
    if (!average) return;
    const score = Number(average.querySelector('.jm-text')?.textContent.trim().replace(',', '.'));
    let stars = average.querySelector('.gp-review-summary-stars');
    if (!Number.isFinite(score) || score <= 0 || score > 5) {
      stars?.remove();
      return;
    }
    if (!stars) {
      stars = document.createElement('span');
      stars.className = 'gp-review-summary-stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = '★★★★★';
      const fill = document.createElement('span');
      fill.textContent = '★★★★★';
      stars.append(fill);
      average.append(stars);
    }
    const fill = `${score / 5 * 100}%`;
    if (stars.style.getPropertyValue('--gp-review-fill') !== fill) stars.style.setProperty('--gp-review-fill', fill);
  };
  const observed = new WeakSet();
  const scan = () => document.querySelectorAll('.jdgm-review-widget').forEach((widget) => {
    if (observed.has(widget)) return;
    observed.add(widget);
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; if (widget.isConnected) enhance(widget); });
    }).observe(widget, { childList: true, subtree: true, characterData: true });
    widget.addEventListener('change', () => requestAnimationFrame(() => enhance(widget)));
    enhance(widget);
  });
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
